import React, { ReactNode } from 'react'
import { useFlags } from 'launchdarkly-react-client-sdk'

import {
  clearCanaryOverrides,
  convertFlagsObjectToConfig,
  getCanaryOverrides,
  setCanaryOverrides,
} from '@bill/canary.browser-utils'
import { CanaryProvider, CanaryStoreEntry } from '@bill/canary.react'
import { rum } from '@divvy-web/utils.log'

import canaryConfig from './canaryConfig'

interface SputnikCanaryProviderProps {
  children: ReactNode
}

export const SputnikCanaryProvider = ({ children }: SputnikCanaryProviderProps) => {
  const launchDarklyFlags = useFlags()
  const flags: CanaryStoreEntry[] = convertFlagsObjectToConfig(launchDarklyFlags)

  return (
    <CanaryProvider
      canaryHashName='#canary-ui'
      config={[...canaryConfig, ...flags]}
      globalName='canary-ui'
      overrides={getCanaryOverrides('canary')}
      onEvaluateFlag={(key, value) => {
        rum && rum.addFeatureFlagEvaluation(key, value)
      }}
      // TODO: update types for setCanaryOverrides to match what is expected on
      //       onFlagChange of CanaryProvider
      //@ts-expect-error
      onFlagChange={setCanaryOverrides('canary')}
      onResetOverrides={clearCanaryOverrides('canary')}
    >
      {children}
    </CanaryProvider>
  )
}
